import styles from "./dateInput.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

type DateInputProps<T extends FieldValues> = {
  disabled?: boolean;
  minDate?: Date;
} & UseControllerProps<T>

export const DateInput = <T extends FieldValues>({ name, minDate, disabled, control }: DateInputProps<T>) => {
  const {
    field: { value: currentValue, onChange, ref },
  } = useController({
    name,
    control,
    defaultValue: undefined
  });

  const selectedDate = currentValue ? new Date(currentValue) : null;

  return (
    <div className={styles.container}>
      <DatePicker className={styles.datePicker}
                  disabled={disabled}
                  selected={selectedDate}
                  minDate={minDate}
                  ref={ref}
                  fixedHeight
                  onChange={(date) => onChange(date)} />
    </div>
  );
}